import React from 'react';
import {
  CompositeNavigationProp,
  useNavigation,
} from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import useAppLocale from '~/data/hooks/useAppLocale';
import { AuthStackParamList, RootStackParamList } from '~/navigation/types';
import { openChat } from '~/utils/respondWidget';
import NotFoundLayout from './layout';

type NotFoundNavProps = CompositeNavigationProp<
  StackNavigationProp<AuthStackParamList>,
  StackNavigationProp<RootStackParamList>
>;

export default function NotFound(): JSX.Element {
  const { locale, onChangeLocale } = useAppLocale();
  const navigation = useNavigation<NotFoundNavProps>();

  const goToMainPage = () => {
    navigation.popToTop();
  };

  const openContactSupport = () => {
    // web only; openChat() is a no-op when the loader has not booted yet
    openChat();
  };

  return (
    <NotFoundLayout
      selectedLocale={locale}
      onSelectedLocale={onChangeLocale}
      goToMainPage={goToMainPage}
      openContactSupport={openContactSupport}
    />
  );
}
